<template>
  <div id="app">
    <Navbar v-if="showNav"/>
    <router-view/>
  </div>
</template>

<script>
  import Navbar from "./components/Navbar";
  import {mixin as VueTimers} from 'vue-timers';

  export default {
    components: {Navbar},
    mixins: [VueTimers],
    timers: {
      enforceLogoutOnInvalidToken: {time: 1 * 1000, autostart: true, repeat: true},
      refreshToken: {time: 5 * 60 * 1000, autostart: true, repeat: true}
    },
    computed: {
      showNav() {
        return this.$store.state.auth.token !== "" && this.$store.state.auth.tokenExp !== 0
      }
    },
    methods: {
      isValidToken() {
        if (this.$store.state.auth.token !== "") {
          // Check if JWT token is still valid, if not push user to login screen
          let now = Date.now().valueOf() / 1000;
          if (this.$store.state.auth.tokenExp > now) {
            return true;
          }
        }
        return false;
      },
      enforceLogoutOnInvalidToken() {
        if (!this.isValidToken()) {
          this.$store.commit("auth/setToken", "")
          this.$store.commit("auth/setUserInfo", {})
          if (this.$route.path !== '/login') {
            this.$router.push({name: "login"})
          }
        }
      },
      refreshToken() {
        if (this.$store.state.auth.token !== "") {
          this.$store.dispatch("auth/refreshToken")
        }
      },
    },
    mounted() {
      this.enforceLogoutOnInvalidToken()
      if (this.isValidToken() && !this.$store.state.auth.user) {
        this.$store.dispatch("auth/obtainUserInfo")
      }
    },
    watch: {
      '$route'() {
        this.enforceLogoutOnInvalidToken()
      }
    }
  }
</script>

<style lang="scss">
  // Customize Buefy
  @import "~bulma/sass/utilities/_all";
  // $primary: #164aef;
  $link: $primary;
  $link-invert: $primary-invert;
  $link-focus-border: $primary;

  @import "~bulma";
  @import "~buefy/src/scss/buefy";

  // Set primary font
  @import url('https://fonts.googleapis.com/css?family=DM+Sans&display=swap&subset=latin-ext');
  body {
    font-family: 'DM Sans', sans-serif;
  }

  // Import icons
  @import '~@mdi/font/css/materialdesignicons.css';

  .navbar.is-light a {
    color: darken($primary, 5%);
  }

  body { /* To compensate for fixed nav bar */
    padding-top: 4rem;
  }
</style>
